import auth from '@/router/auth'
import CategoryItemIndex from '@/components/help-cares/Index'

export default [
  {
    path: '/help-cares',
    name: 'help-cares-index',
    component: CategoryItemIndex,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/help-cares/router.js